export const getFormState = ({ relatedFilmsForm }) => {
    return {
        editing: relatedFilmsForm.editing,
        open: relatedFilmsForm.open,
        id: relatedFilmsForm.id,
    };
};

export const getRelatedFilmFormCallback = ({ relatedFilmsForm }) => relatedFilmsForm.callback;
export const getNewRelatedFilm = ({ relatedFilmsForm }) => relatedFilmsForm.values;


export const formatRelatedFilmToEdit = (relatedFilm) => {

    return {
        filmReleaseID: {
            label: relatedFilm.filmRelease.title,
            value: relatedFilm.filmRelease.id,
            filmRatingTypeId: relatedFilm.filmRelease.filmRatingTypeId,
            ratingReason: relatedFilm.filmRelease.ratingReason
        },
        advertisementFilmReleaseAssociationTypeID: relatedFilm.advertisementFilmReleaseAssociationTypeID,




        dateOccurred: relatedFilm.dateOccurred,
        timeOccurred: relatedFilm.timeOccurred,
        location: relatedFilm.location,
        entryText: relatedFilm.entryText,
        internalComment: relatedFilm.internalComment,

    };
};
